import VueJS from "vue";

const events = new VueJS();

globalThis.$events = events;

export default {
  install(Vue) {
    Vue.prototype.$events = events;
  },
};
